/**
 * Theme Name: project-sscms v1.514.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 884050627]
 * Version: 1.514.0-2025-07-24T18-59-01
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
const scrollArrow = document.querySelectorAll('.scroll-arrow');

const getNextSiblingBySelector = function (elem, selector) {
  let sibling = elem.nextElementSibling;

  if (!selector) return sibling;

  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling;
  }
};

function scrollToBody(e) {
  const thisModule = e.target.closest('.module--block') || e.target.closest('.module');
  const firstModule = getNextSiblingBySelector(thisModule, '.module');
  const firstModuleBlock = getNextSiblingBySelector(thisModule, '.module--block');
  const scrollModule = firstModule || firstModuleBlock;

  scrollModule.scrollIntoView({
    behavior: 'smooth' 
  });
}

if (scrollArrow.length > 0) {
  for (let i = 0; i < scrollArrow.length; i++) {
    scrollArrow[i].addEventListener('click', scrollToBody);
  }
}
